<template>
  <div>
    <masterList
      :tableColumns="tableColumns"
      :module="'assetClassifications'"
      :addNew="addNew"
    ></masterList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import masterList from "../Components/masterList.vue";
export default {
  computed:{
    ...mapState({
         language_terms: state => state.languages.language_terms,
    })

  },
  components: {
    masterList,
  },

  data() {
    return {
      addNew: "/assetclassifications-management/details/_new",
       tableColumns: [
              {
                prop: 'code',
                label: 'CODE',
                minWidth: 100,
                sortable: true,
                key:'CODE'
              },
              {
                prop: 'name',
                label: 'NAME',
                minWidth: 180,
                sortable: true,
                key:'NAME'
              },
              {
                prop: 'remarks',
                label: 'REMARKS',
                sortable: true,
                key:'REMARKS'
              }
        ],

    };
  },
  watch:{
          language_terms: {
            handler(val){
                this.updateTableLang()
            }
        }
  },
  mounted(){
     this.updateTableLang()
  },
  methods:{
    updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    }

  }
};
</script>

<style>
</style>